import dayjs from "dayjs";
import {CropCycle, CropCyclePost} from "../types/domain/cropCycle";

export const toCropCycleClient = (params: CropCyclePost): CropCycle => {
    let plantedDate = null;
    let estHarvestDate = null;
    let actHarvestDate = null;
    if (params.plantedDate) {
        const parsed = dayjs(params.plantedDate);
        if (parsed.isValid()) {
            plantedDate = parsed;
        }
    }
    if (params.estHarvestDate) {
        const parsed = dayjs(params.estHarvestDate);
        if (parsed.isValid()) {
            estHarvestDate = parsed;
        }
    }
    if (params.actHarvestDate) {
        const parsed = dayjs(params.actHarvestDate);
        if (parsed.isValid()) {
            actHarvestDate = parsed;
        }
    }
    const cropCycle = {
        cropId: params.cropId,
        plantedDate: plantedDate ? plantedDate : null,
        variety: params.variety,
        estHarvestDate: estHarvestDate ? estHarvestDate : null,
        actHarvestDate: actHarvestDate ? actHarvestDate : null,
        effRootDepth: params.effRootDepth,
        droughtSensitivity: params.droughtSensitivity,
        resetCropCycle: params.resetCropCycle,
        resetETAppliedWater: params.resetETAppliedWater,
        resetRootDepth: params.resetRootDepth,
    } as CropCycle;

    return cropCycle;
};

export const toCropCyclePost = (params: CropCycle): CropCyclePost => {
    let plantedDate = dayjs().format("YYYY-MM-DD");
    let estHarvestDate = null;
    let actHarvestDate = null;
    if (params.plantedDate && dayjs.isDayjs(params.plantedDate)) {
        plantedDate = params.plantedDate.format("YYYY-MM-DD");
    }
    if (params.estHarvestDate && dayjs.isDayjs(params.estHarvestDate)) {
        estHarvestDate = params.estHarvestDate.format("YYYY-MM-DD");
    }
    if (params.actHarvestDate && dayjs.isDayjs(params.actHarvestDate)) {
        actHarvestDate = params.actHarvestDate.format("YYYY-MM-DD");
    }
    const cropCycle = {
        cropId: params.cropId,
        plantedDate: plantedDate,
        variety: params.variety,
        estHarvestDate: estHarvestDate ? estHarvestDate : null,
        actHarvestDate: actHarvestDate ? actHarvestDate : null,
        effRootDepth: params.effRootDepth,
        droughtSensitivity: params.droughtSensitivity,
        resetCropCycle: params.resetCropCycle,
        resetETAppliedWater: params.resetETAppliedWater,
        resetRootDepth: params.resetRootDepth,
    };

    return cropCycle;
};
